import './assets/loader.css';

import { Loader } from '@pbk-web/ui';
import type { FC } from 'react';
import { lazy, StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';

const IndexWrapped = lazy(() => import('./indexWrapped'));

const Index: FC = () => {
  return (
    <StrictMode>
      <div style={{ width: '100%', minHeight: '100vh' }}>
        <Suspense
          fallback={
            <div
              style={{
                width: '100%',
                height: '100%',
                position: 'fixed',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                zIndex: 9999,
              }}
            >
              <Loader size={32} />
            </div>
          }
        >
          <IndexWrapped />
        </Suspense>
      </div>
    </StrictMode>
  );
};

const root = createRoot(document.getElementById('root')!);
root.render(<Index />);
